import React, {Component} from 'react';
import PropTypes from "prop-types"
import {connect} from 'react-redux'
import {_Object} from "react-utils-y";
import {Theme} from 'theme-y';
// import {Theme} from '../../../theme/index';

import {setFormData, delFormData} from '../../actions/index'
import {inputSty} from './inputStyle';
import {formTypeDom, verifyFn} from './subpage';
import {renderBox} from '../publicField';

const propTypes = {
    designationTheme: PropTypes.string,
    formType: PropTypes.string,
    inputName: PropTypes.string.isRequired,
    formText: PropTypes.string,
    disabled: PropTypes.bool,
    required: PropTypes.bool,
    hintText: PropTypes.string,
    textWidth: PropTypes.string,
    valueWidth: PropTypes.string,
    changeValue: PropTypes.func,
    errorText: PropTypes.string,
    dataType: PropTypes.string,
    // remarks  无规则 自定义传参
    // regex:PropTypes.number,//正则 input特有
    regexText: PropTypes.string,//input特有
};

class InputField extends Theme {
    constructor(props) {
        super(props);
        let _state = {
            focusState: false,//处理点击的样式
            initFocusState: 0,//是否触发过 0 未触发  1 已经触发
            errorState: false,//是否显示报错提示框，  true  显示报错  false  不显示
        };
        this.state = _Object.merge(this.state || {}, _state)
    };

    onfocus = (e) => {
        if (this.props.disabled)return false;
        this.setState({focusState: true})
    };
    onblur = (e) => {
        if (this.props.disabled)return false;
        this.setState({focusState: false, initFocusState: 1});
    };

    onchange = (e) => {
        let props = this.props;
        if (props.disabled || !props.inputName)return false;
        let value = e.target.value.trim();
        //input默认只能输入500个字
        value = value.length > 500 ? value.substring(0, 500) : value;
        let obj = [{
            type: "input",//type 类型
            name: props.inputName,//name input名称
            text: value,//text input值
            value: value,
            obj: {},
            remarks: props.remarks,//备注
            other: {
                required: props.required,
                regex: this.props.regex,// input特有
            }
        }];

        props.setFormData(obj, props.dataType);
        props.changeValue && props.changeValue(obj[0]);
    };

    componentWillMount() {
        let props = this.props;
        let flag = "set";
        try {
            //已经存在数据 就不 重新赋值
            flag = props.formData[props.dataType || "default"][props.inputName] ? "none" : "set"
        } catch (ex) {
            flag = "set"
        } finally {
            if (props.inputName && flag == "set") {
                let obj = [{
                    type: "input",//type 类型
                    name: props.inputName,//name input名称
                    text: "",//text input值
                    value: "",//text input值
                    obj: {},// 无
                    remarks: props.remarks,//备注 传什么进来 传什么出去
                    other: {
                        required: props.required,
                        regex: props.regex,// input特有
                    }
                }];
                props.setFormData(obj, props.dataType);
            }
        }
    }

    componentDidMount() {

    }

    componentWillUnmount() {
        this.props.delFormData(this.props.inputName || "", this.props.dataType)
    }

    render() {
        return renderBox(this, inputSty, formTypeDom, verifyFn)
    }
}

InputField.propTypes = propTypes;

const mapStateToProps = state => {
    return {
        formData: state.formData,
        subVerifyRes: state.subVerifyRes,
        theme: state.theme,
    }
};

const mapDispatchToProps = dispatch => ({
    setFormData: (data, dataType) => dispatch(setFormData(data, dataType)),
    delFormData: (inputName, dataType) => dispatch(delFormData(inputName, dataType))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(InputField)

